<template>
    <div class="contentCart">
        <div v-if="local_products.length > 0">
            <div class="cardProduct" v-for="product in local_products">
                <div class="row">
                    <div class="col-6">
                        <h6>{{ product.NAME }}</h6>
                        <span>{{ product.QUANTITY }} Unidades </span>
                        <h6>{{ (product.POINTS_UNIT_VALUE + product.POINTS_UNIT_SHIPPING) * product.QUANTITY }} puntos</h6>
                    </div>
                    <div class="col-6 img-cart">
                        <img :src="url_media + (product.PRODUCT_IMAGE !== null ? product.PRODUCT_IMAGE.replace('~/', '') : 'image.png')" :alt="product.NAME">
                        <!--                    <img class="trashIcon" src="/img-version2/icons/trash.svg" alt="trash">-->
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <p>Aun no has agregado productos al carrito</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            default: [],
        },
        url_media: {
            default: [],
        },
    },
    data() {
        return {
            loading: 0,
            local_products: [],
            modal_delete_product: false,
            delete_product_guid: 0,
        }
    },
    mounted () {
        this.local_products = this.products
    },
    methods: {
        deleteProduct(product_guid){
            var dataSend = {
                "guid": product_guid,
            }
            axios.post('/delete-product-shopping-cart', dataSend).then(
                ({data}) => {
                    this.local_products = data.products
                    this.$emit('per-page-changed', event.target.value)
                    this.modal_delete_product = false
                    this.delete_product_guid = 0
                })
        },
    },
}
</script>
